module.exports = __webpack_public_path__ + "img/kazuya-min.83a94a2e.png";